<form [formGroup]="pinForm" class="pin-form">
    <form-item-text [subtitle]="settingsSave.inputTitle"></form-item-text>
    <div class="pins">
        <input type="password"
               class="pin-input"
               maxlength="1"
               min="0"
               max="9"
               [formControl]="pin1Control"
               placeholder="*"
               [ngClass]="{ 'pin-input-error': isInvalid1() }" />
        <input type="password"
               class="pin-input"
               maxlength="1"
               min="0"
               max="9"
               [formControl]="pin2Control"
               placeholder="*"
               [ngClass]="{ 'pin-input-error': isInvalid2() }" />
        <input type="password"
               class="pin-input"
               maxlength="1"
               min="0"
               max="9"
               [formControl]="pin3Control"
               placeholder="*"
               [ngClass]="{ 'pin-input-error': isInvalid3() }" />
        <input type="password"
               class="pin-input"
               maxlength="1"
               min="0"
               max="9"
               [formControl]="pin4Control"
               placeholder="*"
               [ngClass]="{ 'pin-input-error': isInvalid4() }" />
    </div>
    <form-action-buttons>
        <form-button [subtitle]="subtitle(3504)"
                     [btnType]="'cancel'"
                     (click)="settingsSave.searchPasswordedElements()">
        </form-button>
        <form-button [subtitle]="subtitle(475)"
                     [btnType]="'confirm'"
                     (click)="getElement()">
        </form-button>
    </form-action-buttons>
</form>
